import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Link } from "react-router-dom";

export default function ApplicationForm() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", portfolio_link: "", skills: "", availability: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/form-submissions", {
        ...form,
        skills: form.skills.split(",").map((s) => s.trim()).filter(Boolean),
      });
      setSubmitted(true);
    } catch (err) { setError(formatApiError(err)); }
  };

  if (submitted) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] p-8">
        <div className="max-w-md w-full border-2 border-black bg-white p-10 text-center">
          <div className="label-caps mb-2">Received</div>
          <h1 className="font-display text-4xl font-bold">Thanks for applying.</h1>
          <p className="text-neutral-600 mt-4">We'll review your application and get back over email if there's a fit.</p>
          <Link to="/login" className="inline-block mt-6 underline underline-offset-4">Studio sign in →</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA] py-10 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="mb-8">
          <div className="label-caps">Freelancer Application</div>
          <h1 className="font-display text-4xl md:text-5xl font-bold mt-2">Join the roster.</h1>
          <p className="text-neutral-600 mt-3">Tell us about your work. Approved applications get an invite to the studio dashboard.</p>
        </div>
        <form onSubmit={submit} className="bg-white border-2 border-black p-6 space-y-4" data-testid="application-form">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div><label className="label-caps block mb-1">Full Name</label><Input data-testid="app-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-none border-black" /></div>
            <div><label className="label-caps block mb-1">Email</label><Input data-testid="app-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="rounded-none border-black" /></div>
            <div><label className="label-caps block mb-1">Phone</label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="rounded-none border-black" /></div>
            <div><label className="label-caps block mb-1">Portfolio Link</label><Input value={form.portfolio_link} onChange={(e) => setForm({ ...form, portfolio_link: e.target.value })} className="rounded-none border-black" /></div>
          </div>
          <div><label className="label-caps block mb-1">Skills (comma separated)</label><Input data-testid="app-skills" value={form.skills} onChange={(e) => setForm({ ...form, skills: e.target.value })} className="rounded-none border-black" /></div>
          <div><label className="label-caps block mb-1">Availability</label><Input placeholder="e.g. 20 hrs/week" value={form.availability} onChange={(e) => setForm({ ...form, availability: e.target.value })} className="rounded-none border-black" /></div>
          <div><label className="label-caps block mb-1">Message</label><Textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="rounded-none border-black" /></div>
          {error && <div className="border border-[#FF2A00] text-[#FF2A00] p-2 text-sm">{error}</div>}
          <div className="flex justify-between items-center">
            <Link to="/login" className="text-sm underline underline-offset-4">Already invited? Sign in →</Link>
            <button data-testid="app-submit" type="submit" className="bg-black text-white px-6 py-3 text-sm hard-shadow-hover">Submit Application</button>
          </div>
        </form>
      </div>
    </div>
  );
}
